<template>
  <div v-if="this.data.broadcastTime > 0" @click="scheduleClick(index)"
       @keydown.enter="scheduleClick(index)"
   :class="'tt-program ' + programClass" :style="scheduleWidth" tabindex=0>
     <!-- 타이틀  -->
    <div class="tt-program-l">
      <template v-if="data.broadcastTime > 5">
        <strong v-if="data.isBroadcast === 'n'" class="tt-no-program">{{ data.title }}</strong>
        <strong v-else class="tt-program-tit">{{ this.replaceTitle(title) }}</strong>
        <span v-if="data.broadcastTime > 5 && data.isBroadcast !== 'n'" class="tt-program-time">
        {{ timeFormat(data.starttime) }} ~ {{ timeFormat(data.endtime) }}
        </span>
        <span v-else class="tt-program-time"></span>
      </template>
    </div>

    <!-- 버튼 -->
    <div v-if="data.isBroadcast !== 'n'" class="tt-program-r">
      <template v-if="bntClass === true">
        <btn-live-alarm :has-title="true" :isOn="data.alarm" :targetDate="data.starttime" :contentsId="channelId" :programId="data.programid" :index="Number(index.replace('-',''))"/>
      </template>
      <a v-if="endTime < today && data.programid" @click.prevent="clickReplayMoveToVod()" :class="bntClass"> {{ bntText }} </a>
      <a v-else-if="bntClass !== true && endTime >= today && channelId" @click.prevent="clickMoveToVodLive()" :class="bntClass"> {{ bntText }} </a>
    </div>

    <!-- 팝업 -->
    <div v-if="isPopup" :id="index" :class="'tt-pop-wrap ' + data.direction">
      <div class="tt-pop">
        <div class="tt-pop-img"><img v-if="data.image" :src="url(data.image)" :alt="channelName"/></div>
        <p class="tt-pop-tit">{{replaceTitle(data.title)}}</p>
        <!-- 버튼 -->
        <p class="tt-pop-time">{{ timeFormat(data.starttime) }} ~ {{ timeFormat(data.endtime) }}</p>
        <div v-if="bntClass === true" class="check-time-pop">
          <btn-live-alarm :has-title="true" :isOn="data.alarm" :targetDate="data.starttime" :contentsId="channelId" :programId="data.programid" :index="Number(index)"/>
        </div>
        <a v-if="(bntClass !== 'tt-btn-play' && data.programid) || (bntClass === 'tt-btn-play' && channelId)" @click.prevent="clickMoveToVodLive()" href="#" :class="bntClass"> {{ bntText }} </a>
        <button @click.stop="popClose(index)" @keydown.enter="popClose(index)"
                class="tt-pop-close">
          <img src="../../assets/images/schedule/popup-btn-close-thin.png" alt=""/>
        </button>
      </div>
    </div>

    <!-- 프로그래스 바 -->
    <div v-if="bntClass === 'tt-btn-play'" class="progress-bar-wrap">
      <div class="progress-bar" :style="progress"></div>
    </div>
  </div>
</template>

<script>
import BtnLiveAlarm from '@/components/button/BtnLiveAlarm'
import { getVodProgramsContentid } from '@/common/utils/request'
import { getDateFromTimeString } from '@/common/utils/common'
import { PATH_NAME_PLAYER_LIVE, PATH_NAME_PLAYER_VOD } from '@/common/resources/router.const'
import { resizeThumbnail } from '@/common/utils/image'
import _ from 'lodash'
export default {
  components: {
    BtnLiveAlarm
  },
  props: {
    data: {
      type: Object
    },
    selectYear: {
      type: Number
    },
    selectDate: {
      type: String
    },
    activeTime: {
      type: Number
    },
    index: {
      type: String
    },
    channelId: {
      type: String
    },
    channelName: {
      type: String
    }
  },
  data () {
    return {
      startTime: '',
      endTime: '',
      today: '',
      isPopup: false,
      title: ''
    }
  },
  computed: {
    short () {
      if (this.data.broadcastTime < 40 && this.data.isBroadcast !== 'n') {
        return 'tt-short'
      }
      return ''
    },
    bntText () {
      if (this.endTime < this.today) {
        return '다시보기'
      } else if (this.startTime <= this.today && this.endTime >= this.today) {
        return '시청하기'
      }
      return ''
    },
    bntClass () {
      if (this.endTime < this.today) {
        return 'tt-btn-again'
      } else if (this.startTime <= this.today && this.endTime >= this.today) {
        return 'tt-btn-play'
      }
      return true
    },
    programClass () {
      let className = ''
      if (this.endTime < this.today) {
        className = 'tt-end '
      } else if (this.startTime <= this.today && this.endTime >= this.today) {
        className = 'tt-ing '
      } else if (this.today < this.startTime) {
        className = 'tt-next '
      } else {
        className = 'tt-no '
      }
      return className + this.short
    },
    progress () {
      let totalTime = this.endTime - this.startTime
      let time = this.today - this.startTime
      return { width: ((time / totalTime) * 100) + '%', position: 'absolute' }
    },
    scheduleWidth () {
      let width = this.data.broadcastTime * 6.277777778
      if (width > 1200) width = 1200
      return { width: width + 'px' }
    }
  },
  methods: {
    clickReplayMoveToVod () {
      getVodProgramsContentid({ programid: this.data.programid }).then((response) => {
        this.$router.push({
          name: PATH_NAME_PLAYER_VOD,
          query: {
            programid: this.data.programid,
            contentid: response.data.contentid ? response.data.contentid : ''
          }
        })
      })
    },
    clickMoveToVodLive () {
      if (this.endTime < this.today) {
        this.$router.push({
          name: PATH_NAME_PLAYER_VOD,
          query: {
            programid: this.data.programid
          }
        })
      } else if (this.startTime <= this.today && this.endTime >= this.today) {
        this.$router.push({
          name: PATH_NAME_PLAYER_LIVE,
          query: {
            channelid: this.channelId
          }
        })
      }
    },
    scheduleClick (index) {
      let element = document.getElementById(index)
      const divs = document.getElementsByClassName('tt-pop-wrap')
      for (let i = 0; i < divs.length; i++) {
        divs[i].classList.remove('tt-pop-wrap-open')
      }

      if (element !== null) {
        element.classList.add('tt-pop-wrap-open')
      }
    },
    popClose (index) {
      let element = document.getElementById(index)
      element.classList.remove('tt-pop-wrap-open')
    },
    timeFormat (sTime) {
      return sTime.substring(sTime.length - 5, sTime.length)
    },
    url (url) {
      return resizeThumbnail(url, { width: 0, height: 0, option: 20, quality: 80 })
    },
    setTitle () {
      if (this.data.broadcastTime === 1) this.title = ''
      else this.title = this.data.title
    },
    resetData () {
      this.startTime = getDateFromTimeString(this.data.starttime) / (1000 * 60)
      this.endTime = getDateFromTimeString(this.data.endtime) / (1000 * 60)
      this.today = new Date() / (1000 * 60)
      this.isPopup = this.short === 'tt-short'
    },
    replaceTitle (title) {
      return _.unescape(title)
    }
  },
  created () {
    this.resetData()
    this.setTitle()
  }
}
</script>
